import  { useState, useEffect, useRef } from "react";
import Keyboard from 'react-simple-keyboard';
import Modal from "../modal";
import Cookies from "universal-cookie";
import moment from 'moment';
import PropTypes from 'prop-types';
import { print } from "./imprime";
import { getBeneficarioxDocFind, 
         getBeneficitas, 
         getBeneficarioxTipoDoc, 
         setRegistrarBeneficiario,
         getBenefAcompant} from "../../services/beneficiario";
import { getRegistrarTurno } from "../../services/public/turno";
import Toasts from "../toast";
import layout from "./layouts/numeric";
import CitasModal from "./citasmodal";
import io from "socket.io-client";
import AcompananteModal from "./acompanante";
//import "./style.css"
 
function BeneficiModal({ show, handleshow, AreaId, ServicioId, Prioritaria, Url, Lector, Acompanant, handleimprime, handleturno }) {
  
  const [numeronit, setNumeroNit] = useState(null);
  const [nombreben, setNombreBen] = useState(null);
  const [tipodoc, setTipoDoc] = useState(null);
  const [historiaid, setHistoriaId] = useState(0);
  const [sexo, setSexo] = useState('');
  const [fechanac, setFechanac] = useState('');
  const [imprime, setImprime] = useState("");
  const [beneficiario, setBeneficiario] = useState("");
  const [tbCitas, settbCitas] = useState([]);
  const [data, setData] = useState([]);
  const [Turno, setTurno] = useState([]);
  const [prioritaria, setPrioritaria] = useState("NO");
  const [acompanante, setAcompanante] = useState("NO");
  
  const [codigo, setCodigo] = useState("");
  const [opciones, setOpciones] = useState([]);
  const [tbBenf, settbBenf] = useState({});
  const [activa, setActiva]= useState(false);
  const [habilita, setHabilita] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showCitas, setShowCitas] = useState(false);
  const [showAcomp, setShowAcomp] = useState(false);
  const [showNoImprime, setShowNoImprime] = useState(false);
  const [consultando, setConsultando] = useState(false);
  const [impresora, setImpresora] = useState("No Definida");
  const [layoutName, setLayoutName] = useState("default");
  const [activakey, setActivaKey]= useState(true);
  const [activalect, setActivaLect]= useState(true);
  const [SolicitanteId, setSolicitanteId] = useState(null);
  const [Solicitantes, setSolicitantes] = useState([]);
  const [loadingSolicitantes, setLoadingSolicitantes] = useState(false);
  
  const inputRef = useRef(null);
  const keyboard = useRef(null);        

//----------------------------------------------------------------------------------------------------------------------
  const onChange= (value)=> 
    {
       setNumeroNit(value);
    }

//----------------------------------------------------------------------------------------------------------------------
  const onChangeInput = (e) => 
   {
     const value = e.target.value;
     setNumeroNit(value);
     keyboard.current?.setInput(value);
   };  

//----------------------------------------------------------------------------------------------------------------------
  function onKeyPress(button) 
  {
     if (button === "{default}" || button === "{letter}") handleShift(button);
     if (button === "{enter}") handleBeneficarioNit();
     if (button === "{cerrar}") 
       {
         setActivaKey(false);
         setHabilita(false);
       }
  }

//---Boton Aceptar------------------------------------------------------------------------------------------------------
  const handleAceptar = async(e) =>
  {
     let documento=null;
     setHabilita(true);
     if (historiaid === 0)
       documento =null;
     else
       documento = numeronit;  

     const Data = {HistoriaId : historiaid, TipoDoc: tipodoc, NumeroNit: documento, NombreBen: nombreben, 
                   Prioritaria: prioritaria, Acompanante:acompanante, SolicitanteId:SolicitanteId};
     const cookies = new Cookies();
    
     setImprime(cookies.get('Simpr'));
     let SImprime = cookies.get('Simpr');
     let Impresora = cookies.get('Impr');
    
     const response = await getRegistrarTurno(AreaId, ServicioId, Data);
     if (response) 
       {
         if (response.status === 200)
           {
             setTurno(response.data.data[0]);
             if ( SImprime ==="SI")
               {
                 setImpresora(cookies.get('Impr'));
                 print(Impresora, response.data.data[0]);
               }  
             else
               handleimprime(true); // sino tiene marcado que imprima muestra en la ventana el turno
             handleshow(false);
             handleturno(response.data.data[0]);
           } 
           else
           {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
           }
        }
     setHabilita(false);
  };

//----------------------------------------------------------------------------------------------------------------------
  const handleCancel = async () => 
  {
     handleshow(false);
  };

//----------------------------------------------------------------------------------------------------------------------
const handleCitas = async() =>
  {
     setShowCitas(true);
  }

//----------------------------------------------------------------------------------------------------------------------
const handleBeneficarioNit = async() =>
  {
     setActiva(true);
     setActivaKey(false);
     setConsultando(true);
     const NumeroNit = document.getElementsByName("searchid")[0].value;
     setNumeroNit(NumeroNit);
     const response = await getBeneficarioxDocFind(NumeroNit);
     if (response)
      {
         if (response.status === 200) 
           {
             if (response.data.data.length === 0)
              {
                 // setNumeroNit(null);
                 setTipoDoc(null);
                 setHistoriaId(0);
                 setFechanac('');
                 setSexo('');
                 setNombreBen('Beneficiario no encontrado');
              }
             else
               if (response.data.data.length > 1)
                 setData(response.data.data)
               else
                {
                   setNumeroNit(response.data.data[0].NumeroNit);
                   setNombreBen(response.data.data[0].NombreBen);
                   setTipoDoc(response.data.data[0].TipoDoc);
                   setHistoriaId(response.data.data[0].HistoriaId);
                   setFechanac(response.data.data[0].FechaNac);
                   setSexo(response.data.data[0].SexoMF);
                   setBeneficiario(response.data.data[0].TipoDoc+' '+ response.data.data[0].NumeroNit+' '+response.data.data[0].NombreBen);
                   setData([]);
                   getCitasBenef(response.data.data[0].HistoriaId);
                   setPrioritaria(response.data.data[0].Prioritaria)
                } 
             setConsultando(false); 
           }   
         else 
          {
             const Mensaje = data.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setConsultando(false);
             setOpciones(opc);
             setShowToast(true);
          }
         setActiva(false);
      }
      else
      {
        const Mensaje = response.message;
        const opc = { type: "Danger", message: Mensaje, active: true };
        setConsultando(false);
        setOpciones(opc);
        setShowToast(true);   
      }
      setHabilita(false);
  }

//----------------------------------------------------------------------------------------------------------------------
 const handlefilas=(item)=>
  {
    setNumeroNit(item.NumeroNit);
    setNombreBen(item.NombreBen);
    setTipoDoc(item.TipoDoc);
    setHistoriaId(item.HistoriaId);
    setFechanac(item.FechaNac);
    setSexo(item.SexoMF);
    setBeneficiario(item.TipoDoc+' '+ item.NumeroNit+' '+item.NombreBen);
    setData([]);
    getCitasBenef(item.HistoriaId);
  }

//----------------------------------------------------------------------------------------------------------------------
 const getCitasBenef = async(HistoriaId) =>
  {
     const response = await getBeneficitas(HistoriaId);
     if (response)
      {
         if (response.status === 200)
          {
             if (response.data.data)
                settbCitas(response.data.data)
          }
         else
         {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true);
         } 
      }
     else
     {
        const Mensaje = response;
        const opc = { type: "Danger", message: Mensaje, active: true };
        setOpciones(opc);
        setShowToast(true);
     } 
  }

//----------------------------------------------------------------------------------------------------------------------
function handleShift(button) 
 {
    if (button === "{letter}")
     {
         let key = document.getElementById('Keyboard1');
         if (key)
          {
             if (document.querySelector("#Keyboard1").classList.contains("keyboardbenedocal"))
                document.querySelector("#Keyboard1").classList.remove("keyboardbenedocal")
             else document.querySelector("#Keyboard1").classList.add("keyboardbenedocal");
          }
     } 
     else
     {
       let keys = document.getElementById('Keyboard1');
       if (keys)
       {
         if (document.querySelector("#Keyboard1").classList.contains("keyboardbenedocal")) 
           document.querySelector("#Keyboard1").classList.remove("keyboardbenedocal");
       }
     } 
     let currentLayout = layoutName;
     let shiftToggle = currentLayout === "default" ? "letter" : "default";
     setLayoutName(shiftToggle);
 }

 //----------------------------------------------------------------------------------------------------------------------
 const handleBeneficarioTipoDoc = async(message) =>
  {
     setActiva(true);
     setActivaKey(false);
     setActivaLect(false)
     setConsultando(true);

     const response = await getBeneficarioxTipoDoc(message.tipodoc, message.documento);
     if (response)
      {
        setShowToast(false);
         if (response.status === 200) 
           {
             if (response.data.data.length === 0)
              {
                 setNumeroNit(null);
                 setNombreBen(null);
                 setTipoDoc(null);
                 setHistoriaId(0);
                 setFechanac('');
                 setSexo('');
                 setBeneficiario('Beneficiario no encontrado');
                 inputRef.current.value=''
                 
                 if (message)
                 {
                  const response = await setRegistrarBeneficiario(
                                message.tipodoc, 
                                message.documento, 
                                message.apellido1, 
                                message.apellido2, 
                                message.nombre1, 
                                message.nombre2,
                                message.nombre_completo, 
                                message.genero, 
                                message.fecha_nacimiento, 
                                message.tipo_sangre);
                   if (response)
                    {
                      if (response.status === 200) 
                       {
                          setNumeroNit(response.data.data[0].NumeroNit);
                          setNombreBen(response.data.data[0].NombreBen);
                          setTipoDoc(response.data.data[0].TipoDoc);
                          setHistoriaId(response.data.data[0].HistoriaId);
                          setFechanac(response.data.data[0].FechaNac);
                          setSexo(response.data.data[0].SexoMF);
                          setBeneficiario(response.data.data[0].TipoDoc+' '+ response.data.data[0].NumeroNit+' '+response.data.data[0].NombreBen);
                          setData([]);
                          getCitasBenef(response.data.data[0].HistoriaId);   
                          setPrioritaria(response.data.data[0].Prioritaria)
                       }
                      else 
                        {
                           const Mensaje = response.message;
                           const opc = { type: "Danger", message: Mensaje, active: true };
                           setOpciones(opc);
                           requestAnimationFrame(() =>setShowToast(true));
                        }        
                    }
                   else 
                    {
                       const Mensaje = response.message;
                       const opc = { type: "Danger", message: Mensaje, active: true };
                       setOpciones(opc);
                       requestAnimationFrame(() =>setShowToast(true));
                     }
                  }
                }    
             else
               if (response.data.data.length > 1)
                 setData(response.data.data)
               else
                {
                   setNumeroNit(response.data.data[0].NumeroNit);
                   setNombreBen(response.data.data[0].NombreBen);
                   setTipoDoc(response.data.data[0].TipoDoc);
                   setHistoriaId(response.data.data[0].HistoriaId);
                   setFechanac(response.data.data[0].FechaNac);
                   setSexo(response.data.data[0].SexoMF);
                   setBeneficiario(response.data.data[0].TipoDoc+' '+ response.data.data[0].NumeroNit+' '+response.data.data[0].NombreBen);
                   setData([]);
                   getCitasBenef(response.data.data[0].HistoriaId);
                   setPrioritaria(response.data.data[0].Prioritaria)
                } 
                setConsultando(false); 
           }   
           else 
           {
             const Mensaje = data.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setConsultando(false);
             setOpciones(opc);
             requestAnimationFrame(() =>setShowToast(true));
           }
         setActiva(false);
      }
      else
      {
        const Mensaje = response;
        const opc = { type: "Danger", message: Mensaje, active: true };
        setConsultando(false);
        setOpciones(opc);
        setShowToast(true);   
      }
      setHabilita(false);
      setActivaLect(true);
  }
//----------------------------------------------------------------------------------------------------------------------
const handleNuevoSolicitante = () => {
  setShowAcomp(true);
};
//----------------------------------------------------------------------------------------------------------------------
const handleSolicitanteDiferente = async (e) => {
  const valor = e.target.checked ? "SI" : "NO";

  setAcompanante(valor);

  if (valor === "NO") 
    {
      setSolicitantes([]);
      setSolicitanteId(null);
      return;
    }

  try 
  {
    setLoadingSolicitantes(true);
    const response = await getBenefAcompant(historiaid);
     if (response)
      {
        setShowToast(false);
         if (response.status === 200) 
           setSolicitantes(response.data.data || []);
      }   
     else 
      {
        const Mensaje = data.message;
        const opc = { type: "Danger", message: Mensaje, active: true };
        setOpciones(opc);
        requestAnimationFrame(() =>setShowToast(true));
        setShowToast(true);
      }       
  } finally {
    setLoadingSolicitantes(false);
  }
};
//----------------------------------------------------------------------------------------------------------------------
const handleServicioGuardado = (servicioGuardado) => {
  setSolicitantes((prev) => {
    // Busca si ya existe la combinación AreaId + ServicioId
    const existe = prev.some(
      (s) =>
        s.HistoriaId === servicioGuardado.HistoriaId &&
        s.AcompantId === servicioGuardado.AcompantId
    );

    if (existe) {
      // Actualiza únicamente el registro que tenga ambas llaves
      return prev.map((s) =>
        s.HistoriaId === servicioGuardado.HistoriaId &&
        s.AcompantId === servicioGuardado.AcompantId
          ? servicioGuardado
          : s
      );
    }

    // Si no existe esa combinación, agrega el nuevo servicio
    return [...prev, servicioGuardado];
    
  });
  
 // Dejar seleccionado automáticamente el nuevo registro
  setSolicitanteId(servicioGuardado.AcompantId);
}

//----------------------------------------------------------------------------------------------------------------------
 useEffect(() => {
  if (Lector !== 'SI') return;
  
  const socket = io(Url);
  socket.on("connect",() =>{})
  socket.on("connect_error",(err) =>{console.log('Error de conexion', err.message)})
  socket.on("disconnect",() =>{})
  socket.on("barcode", (message) => 
        {
         if ((message) && (activalect))
          {
            setNumeroNit(message.documento)
            setTipoDoc(message.tipodoc)
            handleBeneficarioTipoDoc(message)
          }
        });
 
  return () => {
    return socket.disconnect();
   };
  
}, [Lector, Url]);

//----------------------------------------------------------------------------------------------------------------------
 useEffect(() => 
    {
       if (show)
        {
           setNumeroNit(null);
           setPrioritaria("NO");
           setNombreBen(null);
           setTipoDoc(null);
           setFechanac('');
           setSexo('');
           setHistoriaId(0);
        }
       if (inputRef.current)
        {
           inputRef.current.focus();
        }
  }, [show]);

//----------------------------------------------------------------------------------------------------------------------  
return(
    <>
    <Modal isOpen={show} onClose={()=>handleshow(false)} title={'Registrar Beneficiario'}>
              <div className="flex  flex-col lg:w-full lg:min-w-[35rem] h-auto">
          <div className="flex  lg:w-full h-full">
              <div name='ladoIzquierdo' className="flex flex-col flex-1 pr-4 ">
                 <form noValidate className="w-full" >
                     <div className="w-full">
                        <label>Documento del paciente</label>
                        <input type="text" name='searchid' value={numeronit||''} placeholder="Buscar Beneficiario..." 
                                autoComplete="off"  ref={inputRef} onChange={onChangeInput}
                        ></input>
                      </div> 
                  </form>
                  <div className={ data.length >0 ? "block" : "hidden"}>
                     <table className="w-full absolute z-10  bg-white border border-gray-300 rounded shadow-lg mt-1">
                        <thead className="border-b border-stone-200 text-sm font-medium ">
                           <tr>
                              <th className="px-2.5 py-2 text-start font-medium">T.D.</th>
                              <th className="px-2.5 py-2 text-start font-medium">Documento</th>
                              <th className="px-2.5 py-2 text-start font-medium">Nombre</th>
                              <th className="px-2.5 py-2 text-start font-medium">Sexo</th>
                           </tr>
                        </thead>
                        <tbody className="group text-sm text-stone-800 ">
                           {data.map((item) => (
                              <tr className="border-b border-stone-200 last:border-0" key={item.HistoriaId}  onClick={() => handlefilas(item)}>
                                 <td>{item.TipoDoc}</td>
                                 <td>{item.NumeroNit}</td>
                                 <td>{item.NombreBen}</td>
                                 <td>{item.SexoMF}</td>
                              </tr>
                           ))}
                        </tbody>
                     </table>      
                  </div>
                  <div className="flex flex-col mt-3">
                    <ul className="grid grid-cols-[max-content_1fr] gap-x-2 gap-y-1 border border-gray-400 rounded-md py-2 px-2">
                        <label className="text-right">Documento:</label>
                        <label className="text-sidebar">
                            {tipodoc} {numeronit}
                        </label>

                        <label className="text-right">Nombre:</label>
                        <label className="text-sidebar">
                            {nombreben}
                        </label>

                        <label className="text-right">Fecha Nac.:</label>
                        <label className="text-sidebar">
                            {fechanac && moment(fechanac).format('DD/MM/YYYY')}
                        </label>

                        <label className="text-right">Sexo:</label>
                        <label className="text-sidebar">
                            {sexo === '' ? null : sexo === 'M' ? 'Masculino' : 'Femenino'}
                        </label>

                        <label className="text-right">Cita:</label>
                        <label className={`${tbCitas.length > 0 ? 'text-sidebar hover:cursor-pointer': 'hidden'}`}>
                            <div onClick={handleCitas}>Ver Citas</div>
                        </label>
                    </ul>
                      { Acompanant ==="SI" &&
                      (
                          <div className="flex flex-col gap-2 mt-2 mb-3">
                            <div className="flex">
                              <input type="checkbox" className="mr-2" checked={acompanante === "SI"}   onChange={handleSolicitanteDiferente} disabled={historiaid==0}/>
                              <label className="">Solicitante diferente al paciente</label>  
                            </div>
                              {acompanante === "SI" && 
                              (
                                <div className="w-full border border-gray-400 rounded-md overflow-hidden">
                                  <div className="flex items-center justify-between px-3 py-2 border-b border-gray-400 bg-gray-50">
                                    <span className="text-sm font-medium text-gray-600">
                                        Solicitantes registrados ({Solicitantes.length})
                                    </span>
                                    <button type="button" onClick={handleNuevoSolicitante} className="nobutton text-sm font-medium text-default hover:underline">
                                      + Nuevo solicitante
                                    </button>
                                  </div>
                                    {loadingSolicitantes ? (

                                      <div className="flex items-center justify-center py-5 px-3">
                                        <span className="text-sm text-gray-400">
                                          Consultando solicitantes...
                                        </span>
                                      </div>

                                    ) : Solicitantes.length > 0 ? (

                                      <div className="max-h-[5rem] overflow-y-auto">
                                        {Solicitantes.map((item) => {
                                          const seleccionado =
                                            SolicitanteId === item.AcompantId;

                                          return (
                                            <label
                                              key={item.AcompantId}
                                              className={`flex items-center gap-3 px-3 py-2
                                                border-b border-gray-100 cursor-pointer
                                                transition-colors last:border-b-0 ${
                                                  seleccionado
                                                    ? "bg-gray-50"
                                                    : "hover:bg-gray-50"
                                                }`}
                                            >
                                              <input
                                                type="radio"
                                                name="solicitante"
                                                checked={seleccionado}
                                                onChange={() =>
                                                  setSolicitanteId(item.AcompantId)
                                                }
                                                className="h-4 w-4"
                                              />

                                              <div className="flex flex-col flex-1 min-w-0">
                                                <span className="text-sm font-medium text-gray-700 truncate">
                                                  {item.NombreAcomp}
                                                </span>

                                                <span className="text-xs text-gray-400">
                                                  {item.TipoDoc} {item.NumeroNit}
                                                </span>
                                              </div>

                                              {item.TelefAcomp && (
                                                <span className="hidden md:block text-xs text-gray-500">
                                                  {item.TelefAcomp}
                                                </span>
                                              )}
                                            </label>
                                          );
                                        })}
                                      </div>

                                    ) : (

                                      <div className="flex flex-col items-center justify-center py-5 px-3">
                                        <span className="text-sm text-gray-400">
                                          No hay solicitantes registrados
                                        </span>

                                        <button
                                          type="button"
                                          onClick={handleNuevoSolicitante}
                                          className="nobutton mt-2 text-sm font-medium text-default hover:underline"
                                        >
                                          + Registrar solicitante
                                        </button>
                                      </div>

                                    )}                                  
                                </div>
                              )}
                        </div>
                      )}
                  </div>

                  <div className="flex mt-auto">
                     <input type="checkbox" className="mr-2" checked={prioritaria === "SI"} onChange={(e) => e.target.checked ? setPrioritaria("SI") : setPrioritaria("NO")}/>
                     <label className="">Ubicar el paciente en cola Prioritaria</label>   
                  </div>
               </div>
               <div name='ladoderecho' className="flex-2">
                  <div className="w-full h-full p-0" id="Keyboard1">
                      <Keyboard
                         {...layout}
                         keyboardRef={(r) => (keyboard.current = r)}
                        // onChange = {(button)=> onChange(button)}
                         onKeyPress = {button => onKeyPress(button)}
                         onChange={onChange}
                         //onKeyPress={onKeyPress}
                         layoutName ={layoutName}
                         autoUseTouchEvents= {false}
                         mergeDisplay = {true}
                       />
                  </div>
               </div>
          </div> 
        <div className="flex w-full gap-4 mt-6 justify-end">
            <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
            <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
        </div>
      </div>      
     </Modal>
     {showCitas && (
           <CitasModal show={showCitas} handleshow={setShowCitas} Citas={tbCitas} >
           </CitasModal>
           ) 
     }
     {showToast && (
                 <Toasts
                   type={opciones.type}
                   message={opciones.message}
                   active={opciones.active}
                 ></Toasts>
               ) 
      }

     {showAcomp && (
           <AcompananteModal show={showAcomp} handleshow={setShowAcomp} HistoriaId={historiaid} onGuardado={handleServicioGuardado} />
           
           ) 
     }

     {consultando && (
          <div className="fixed inset-0 bg-black/40 z-[10000] flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 shadow-lg text-center">
              <div className="animate-spin h-8 w-8 border-4 border-gray-300 border-t-blue-600 rounded-full mx-auto mb-4"></div>
              <p className="text-gray-700 font-medium">Consultando Datos...</p>
              <p className="text-sm text-gray-500">Por favor espere</p>
            </div>
          </div>
       )}


    </>
  );
}

BeneficiModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleshow: PropTypes.func.isRequired,
  AreaId: PropTypes.number.isRequired,
  ServicioId: PropTypes.number.isRequired,
  Prioritaria: PropTypes.string,
  Url: PropTypes.string,
  Lector: PropTypes.string,
  Acompanant: PropTypes.string,
  handleimprime: PropTypes.func.isRequired,
  handleturno: PropTypes.func.isRequired,
};

export default BeneficiModal;
